import { ToolTip } from '@undp_sdg_ai_lab/undp-radar';

import { PopOver } from 'components/PopOver';

export const PopOverView: React.FC = () => (
  <ToolTip>
    <PopOver />
  </ToolTip>
);
